import getFriendService from '../services/components/get_friends.jsx'


const getState = (friendsState) => ({ type: "GET_FRIENDS", friendsState })

export const getFriendsAction = () => dispatch => {
    let state = [];

    getFriendService((data, msg) => {

        if (msg === "success") {

            state = {
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch(getState(state))
    })
} 


// WEBPACK FOOTER //
// ./src/actions/getfriendaction.jsx